'use client';

import { createContext } from 'react';

export type FeatureFlagContextValue = {
    isEnabled: (flag: string) => boolean;
};

export const FeatureFlagContext = createContext<FeatureFlagContextValue | null>(
    null
);
